import React from 'react'



const AppContextApi = React.createContext()


export{AppContextApi}